import React from 'react';

import PermissionSection from './PermissionSection';
import { permissionsDataPropType } from './permissionsData';


const Permissions = ({ permissionSections }) => (
  <React.Fragment>
    {permissionSections.map(permissionSection => (
      <PermissionSection data={permissionSection} key={permissionSection.sectionId} />
    ))}
  </React.Fragment>
);

Permissions.propTypes = {
  permissionSections: permissionsDataPropType.isRequired,
};

export default Permissions;
